<dl>
  <dt class="mb-3">
    <strong>Etapy</strong>
  </dt>
  <dd>
    <ol class="ps-5" type="1">
      @for (stage of occupation?.stages; track $index) {
        <li class="mb-4">
          <div class="row">
            <div class='col-md-4'>
              <app-label label='Data od:'>
                {{ stage?.startDate | date }}
              </app-label>
            </div>
            <div class='col-md-4'>
              <app-label label='Data do:'>
                {{ stage?.endDate | date }}
              </app-label>
            </div>
            <div class="col-md-4">
              <app-label label="Ilość dni:">
                {{ stage.dayQuantity }}
              </app-label>
            </div>
          </div>
          <br>
          <table class='table table-silver'>
            <thead>
            <th>
              Typ reklamy
            </th>
            </thead>
            <tbody>
            <tr>
              <td>
                {{ stage.adType }}
              </td>
            </tr>
            </tbody>
          </table>
          <br>
          <table class='table table-silver'>
            <thead>
            <th>
              Wysokość reklamy (m)
            </th>
            <th>
              Długość reklamy (m)
            </th>
            <th>
              Ilość (szt)
            </th>
            <th>
              Łączna powierzchnia reklamy (m<sup>2</sup>)
            </th>
            </thead>
            <tbody>
            <tr>
              <td>
                {{ stage.adWidth }}
              </td>
              <td>
                {{ stage.adLength }}
              </td>
              <td>
                {{ stage.adQuantity }}
              </td>
              <td>
                {{ stage.adArea }}
              </td>
            </tr>
            </tbody>
          </table>
          <br>
          <dl>
            <dt class="mb-3">
              <strong>Działki</strong>
            </dt>
            <dd>
              <app-parcels-preview [parcels]="stage.parcels || []"></app-parcels-preview>
            </dd>
          </dl>
          <br>
          <div class="row">
            <div class="col-12">
              <app-label label="Geometria:">
                brak
              </app-label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <app-label label="Miejscowość:">
                {{ stage.city }}
              </app-label>
            </div>
            @if (stage.roadNumber; as roadNumber) {
              <div class="col-md-4">
                <app-label label="Numer drogi:">
                  {{ roadNumber }}
                </app-label>
              </div>
            }
            @if (stage.roadName; as roadName) {
              <div class="col-md-4">
                <app-label label="Nazwa drogi:">
                  {{ roadName }}
                </app-label>
              </div>
            }
            @if (stage.street; as street) {
              <div class="col-md-4">
                <app-label label="Ulica:">
                  {{ street }}
                </app-label>
              </div>
            }
          </div>
          <div class="row">
            <div class="col-12">
              <app-label label="Treść tablicy reklamowej:">
                {{ stage.adContent }}
              </app-label>
            </div>
          </div>
        </li>
        @if (!$last) {
          <hr>
        }
      }
    </ol>
  </dd>
</dl>
